export { StatisticsService } from '../services/statistics.service';

